<div class="modal-header">
    <h5 class="modal-title">Add to Folder</h5>
    <button
        (click)="activeModal.dismiss('Cross click')"
        aria-label="Close"
        class="btn-close"
        data-dismiss="modal"
        type="button"
    ></button>
</div>
<div class="modal-body">
    <div>Select Folders:</div>
    <app-preloader *ngIf="!folders" class="mt-4 mb-4"></app-preloader>
    <div *ngFor="let wrapper of folders" class="folder-item mb-2 mt-2">
        <app-input-box
            [(inputModel)]="wrapper.isSelected"
            [label]="wrapper.folder.name"
            inputType="checkbox"
        ></app-input-box>
    </div>
    <div class="folder-item new-folder mb-2 mt-2 p-1">
        <app-checkbox [(checked)]="isNewFolderSelected"> </app-checkbox>
        <input
            [(ngModel)]="newFolderName"
            [disabled]="!isNewFolderSelected"
            class="ms-3"
            placeholder="New Folder"
            type="text"
        />
    </div>
</div>
<div class="modal-footer">
    <button
        (click)="activeModal.dismiss('Save Updates'); saveUpdates()"
        class="btn btn-primary"
        type="button"
    >
        Save Updates
    </button>
</div>
